"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconRaiseHand = function IconRaiseHand(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconRaiseHand', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.928 8.348V2.272c0-1.696 2.63-1.696 2.63 0v2.973a1.326 1.326 0 0 1 1.772.59 1.326 1.326 0 0 1 1.924.553c.877-.552 2.02.088 2.02 1.09 0 2.078.153 4.84-1.434 6.436-1.458 1.465-4.487 1.408-6.03.068-1.387-1.207-3.036-3.755-3.7-5.44-.616-1.569 1.507-2.429 2.315-1.053l.503.86z"
  }));
};

var _default = IconRaiseHand;
exports.default = _default;